import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { Github, Twitter, Linkedin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-border" role="contentinfo">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company */}
          <div>
            <h3 className="font-semibold text-white mb-4">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">About Us</Link></li>
              <li><Link to="/careers" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">Careers</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">Contact</Link></li>
            </ul>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-semibold text-white mb-4">Product</h3>
            <ul className="space-y-3">
              <li><Link to="/buy" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">On-Ramp Solutions</Link></li>
              <li><Link to="/buy" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">Off-Ramp Solutions</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">Business Wallets</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">White-Label Widgets</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-4">Resources</h3>
            <ul className="space-y-3">
              <li><a href="https://docs.nowramp.com/" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">Documentation</a></li>
              <li><a href="#" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">Help Center</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-white mb-4">Legal</h3>
            <ul className="space-y-3">
              <li><Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">Privacy Policy</Link></li>
              <li><Link to="/aml-policy" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">AML/KYC Policy</Link></li>
              <li><Link to="/cookie-policy" className="text-muted-foreground hover:text-primary transition-colors focus:outline-none focus:ring-2 focus:ring-primary rounded">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-border" />

        {/* Regulatory Disclaimer */}
        <div className="mb-8">
          <p className="text-xs text-muted-foreground leading-relaxed text-center max-w-4xl mx-auto">
            <strong className="text-muted-foreground/80">Regulatory Notice:</strong> NowRamp is a technology platform that provides technical infrastructure for accessing third-party services. NowRamp does not provide financial services, exchange services, payment services, or custody services. Fiat-to-crypto and crypto-to-fiat conversion services are provided exclusively by independent, licensed third-party providers ("Fiat Gateways"). NowRamp does not hold, transmit, or control user funds or crypto assets. All transactions are processed directly by Fiat Gateways under their own terms and regulatory licences.
          </p>
        </div>

        {/* Bottom section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex flex-col items-center md:items-start gap-1">
            <p className="text-muted-foreground text-sm">
              © {currentYear} Carlton Interactive Limited. All rights reserved.
            </p>
            <p className="text-muted-foreground text-xs">
              Incorporated in the British Virgin Islands | Company No. 2160976
            </p>
            <p className="text-muted-foreground text-sm">
              info@nowramp.io
            </p>
          </div>
          
          <div className="flex items-center gap-4">
            <a 
              href="#" 
              className="w-10 h-10 rounded-lg bg-card border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 transition-all focus:outline-none focus:ring-2 focus:ring-primary"
              aria-label="Follow us on Twitter"
            >
              <Twitter className="w-5 h-5" aria-hidden="true" />
            </a>
            <a 
              href="#" 
              className="w-10 h-10 rounded-lg bg-card border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 transition-all focus:outline-none focus:ring-2 focus:ring-primary"
              aria-label="Connect on LinkedIn"
            >
              <Linkedin className="w-5 h-5" aria-hidden="true" />
            </a>
            <a 
              href="#" 
              className="w-10 h-10 rounded-lg bg-card border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 transition-all focus:outline-none focus:ring-2 focus:ring-primary"
              aria-label="View our GitHub"
            >
              <Github className="w-5 h-5" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
